import { PARAMS } from 'constants/pages';

export const SUCCESSION_SETTINGS_FIELD_NAMES = {
  READINESS: 'readiness_levels',
  CRITICALITY: 'criticality_levels',
  REMOVAL_REASONS: 'removal_reasons',
  JOB_FAMILIES: 'job_families',
  GENERIC_COVERAGE_RATIO: 'generic_coverage_ratio',
};

export const REMOVAL_REASON_USED_BY = {
  SYSTEM: 'system',
  USERS: 'users',
  SYSTEM_AND_USERS: 'system_and_users',
};

export const KEY_JOB_TYPES = {
  SEAT: 'seat',
  GENERIC: 'generic',
};

export const COVERAGE_STATUS = {
  COVERED: 'covered',
  PARTIAL: 'partial',
  GAP: 'gap',
};

export const SUCCESSOR_FORM_MODE = {
  ADD: 'add',
  EDIT: 'edit',
  REMOVE: 'remove',
  READD: 'readd',
};

export const SUCCESSOR_PERSON_SOURCE = {
  EMPLOYEES: 'employees',
  POOL: 'pool',
};

export const SUCCESSOR_STATUSES = {
  ACTIVE: 'active',
  REMOVED: 'removed',
};

export const SUCCESSOR_FIELDS = {
  USER: 'user',
  READINESS: 'readiness_level',
  RANK: 'rank',
  NOTE: 'note',
  REASON: 'reason',
  COMMENT: 'comment',
};

export const CHANGE_LOG_ACTIONS = {
  ADDED: 'added',
  UPDATED: 'updated',
  REMOVED: 'removed',
  RANK_CHANGED: 'rank_changed',
  KEY_SET: 'key_set',
  KEY_UNSET: 'key_unset',
};

export const CHANGE_LOG_FIELDS = {
  READINESS: 'readiness',
  NOTE: 'note',
};

export const SUCCESSION_POOL_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
};

export const SUCCESSION_POOL_INDICATOR_KEYS = {
  [SUCCESSION_POOL_STATUS.ACTIVE]: 'done',
  [SUCCESSION_POOL_STATUS.ARCHIVED]: 'deactivated',
};

export const SUCCESSION_POOL_FILTER = {
  STATUS: PARAMS.STATUS,
  OWNER: PARAMS.OWNER,
};

export const SUCCESSION_POOL_FIELDS = {
  NAME: 'name',
  DESCRIPTION: 'description',
  OWNER: 'owner',
  MEMBERS: 'members',
};

export const SUCCESSION_POOL_MEMBER_FIELDS = {
  EMPLOYEE: 'employee',
  READINESS: 'readiness',
  NOTE: 'note',
  REASON: 'removal_reason',
  COMMENT: 'comment',
};

export const POOL_FORM_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
};

export const SUCCESSION_POOL_MEMBER_FORM_MODE = {
  ADD: 'add',
  EDIT: 'edit',
  REMOVE: 'remove',
};

export const SUCCESSION_USER_STATUSES = {
  ACTIVE: 'active',
  REMOVED: 'removed',
};

export const SUCCESSION_USER_INDICATOR_KEYS = {
  [SUCCESSION_USER_STATUSES.ACTIVE]: 'done',
  [SUCCESSION_USER_STATUSES.REMOVED]: 'rejected',
};

export const SUCCESSION_NAVIGATION_ITEMS = [
  {
    key: 'keyJobs',
    url: '/succession/key-jobs',
    translationKey: 'keyJobs',
    end: false,
  },
  {
    key: 'pools',
    url: '/succession/pools/?page=1&status=active',
    translationKey: 'pools',
    end: false,
  },
  {
    key: 'settings',
    url: '/succession/settings',
    translationKey: 'settings',
    end: true,
  },
];
